import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal, Chapter } from "./shared";

const PHOTO_SECTORS = [
  {
    name: "Boutique Hotels",
    img: "/assets/sector-hotel.webp",
    benefit: "Rooms stay cool without blackout curtains. Guests keep the sea view, you cut the AC load.",
  },
  {
    name: "Commercial & Offices",
    img: "/assets/sector-office.webp",
    benefit: "End screen glare and the hot-desk-by-the-window problem. A comfortable floor is a productive floor.",
  },
  {
    name: "Real Estate & Showrooms",
    img: "/assets/sector-retail.webp",
    benefit: "Stop UV from bleaching stock, displays and interiors while spaces stay bright for viewings.",
  },
  {
    name: "Property Managers",
    img: "/assets/sector-property-managers.webp",
    benefit: "Fewer tenant complaints about overheating and glare. One fixed quote per block, no capex-heavy window replacement.",
  },
  {
    name: "Airbnb & Short-lets",
    img: "/assets/sector-airbnb.webp",
    benefit: "Cooler apartments review better. Protect furnishings between turnovers, not after they've faded.",
  },
];

export default function Sectors() {
  return (
    <section id="sectors" data-testid="sectors-section" className="pt-20 md:pt-32 pb-10 md:pb-14">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Chapter title="Who It's For" />

        <div className="mt-10 grid md:grid-cols-3 gap-4 md:gap-8">
          {PHOTO_SECTORS.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.08} className="group">
              <div className="border border-slate-300 bg-white h-full flex md:block">
                <div className="relative w-28 sm:w-32 md:w-full shrink-0 md:aspect-[4/3] overflow-hidden border-r md:border-r-0 md:border-b border-slate-300">
                  <img
                    src={s.img}
                    alt={s.name}
                    loading="lazy"
                    className="absolute inset-0 md:relative w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 md:p-8">
                  <h3 className="font-heading font-bold text-lg md:text-2xl text-slate-900 flex items-center justify-between gap-3">
                    {s.name}
                    <ArrowUpRight
                      size={20}
                      className="text-slate-300 shrink-0 group-hover:text-[#0284C7] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-[color,transform] duration-150"
                    />
                  </h3>
                  <p className="mt-2 md:mt-3 text-sm md:text-base text-slate-600 leading-relaxed">
                    {s.benefit}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
